<script>
  import { clipPathCode } from "$lib/utils/flowerClipath";
  /**@type {string}*/
  export let title = "";
  /**@type {string}*/
  export let description = "";
  /**@type {string}*/
  export let text = "";
  /**@type {string}*/
  export let link;
  /**@type {import ('$lib/types').MediaQueryImages}*/
  export let image;
  export let isOrange = true;
</script>

<div class="container" class:reverse={!isOrange}>
  <div style={`clip-path: polygon(${clipPathCode})`} class="mask_one">
    <div style={`clip-path: polygon(${clipPathCode})`} class="mask_two">
      <div style={`clip-path: polygon(${clipPathCode})`} class="mask_tree">
        <div style={`clip-path: polygon(${clipPathCode})`} class="mask_four">
          <div class="flower">
            <img
              src={image.img}
              srcset={`${image.img} 1x, ${image.img2x} 2x, ${image.img3x} 3x`}
              alt={title}
              style={`clip-path: polygon(${clipPathCode})`}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="label-back">
    <div class="info">
      <h3>{@html title}</h3>
      <h5>{@html description}</h5>
      <p>{@html text}</p>
      <a href={link}>
        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58">
          <g id="Grupo_288" data-name="Grupo 288" transform="translate(0.149)">
            <circle
              id="Elipse_3"
              data-name="Elipse 3"
              cx="29"
              cy="29"
              r="29"
              transform="translate(-0.149)"
              fill="transparent"
            />
            <path
              id="Path_228"
              data-name="Path 228"
              d="M-370.515,11854.9a.981.981,0,0,1-.592-.2.986.986,0,0,1-.2-1.381l11.2-14.883L-371.293,11824a.986.986,0,0,1,.175-1.384.985.985,0,0,1,1.383.175l12.109,15.624-.453.6-11.648,15.485A.984.984,0,0,1-370.515,11854.9Z"
              transform="translate(406.463 -11809.544)"
              fill="#fcf3e8"
            />
            <path
              id="Line_17"
              data-name="Line 17"
              d="M36.421.472H-.514A.986.986,0,0,1-1.5-.514.986.986,0,0,1-.514-1.5H36.421a.986.986,0,0,1,.986.986A.986.986,0,0,1,36.421.472Z"
              transform="translate(11.01 29.382)"
              fill="#fcf3e8"
            />
          </g>
        </svg>
      </a>
    </div>
    <div class="mask_back" style={`clip-path: polygon(${clipPathCode})`}></div>
  </div>
  {#if isOrange}
    <div class="decorate-orange">
      <picture>
        <img src="/images/home/fortify_assets.webp" alt="" />
      </picture>
    </div>
  {:else}
    <div class="decorate-pink">
      <picture>
        <source
          srcset="/images/home/heart.webp 1x, /images/home/heart@2x.webp 2x, /images/home/heart@3x.webp 3x"
        />
        <img src="/images/home/heart.webp" alt="" />
      </picture>
    </div>
  {/if}
</div>

<style>
  :root {
    --primary: #fdb048;
    --secondary: #fcf3e8;
    --primary-reverse: #fc9dc9;
    --secondary-reverse: #f5dfe7;
  }
  .container {
    aspect-ratio: 1.8/1;
    width: 100svw;
    max-height: 85svh;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    z-index: 2;
  }
  .reverse {
    justify-content: flex-start;
  }
  .reverse::before {
    content: "";
    width: 100%;
    height: 50%;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: var(--orange-light);
    z-index: -1;
  }
  .label-back {
    width: 100svw;
    height: 80%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    bottom: inherit;
    z-index: -1;
    overflow: hidden;
    background: transparent linear-gradient(91deg, #fb5caa 0%, #f5dfe7 100%) 0% 0% no-repeat
      padding-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12%;
  }
  .reverse > .label-back {
    flex-direction: row-reverse;
    justify-content: flex-end;
    background: transparent linear-gradient(270deg, #fb5caa 0%, #fdb048 100%) 0% 0% no-repeat
      padding-box;
  }
  .mask_back {
    height: 100%;
    aspect-ratio: 1/1;
    background-color: var(--primary);
    padding: 1.5rem;
    margin-right: -10%;
  }
  .reverse .mask_back {
    margin-right: inherit;
    margin-left: -10%;
    background-color: var(--primary-reverse);
  }
  .mask_one {
    height: 100%;
    aspect-ratio: 1/1;
    background-color: var(--global);
    padding: 1.5rem;
    margin-right: -10%;
  }
  .mask_two {
    aspect-ratio: 1/1;
    background-color: var(--secondary);
    padding: 1.5rem;
  }
  .mask_tree {
    aspect-ratio: 1/1;
    background-color: var(--global);
    padding: 1.5rem;
  }
  .mask_four {
    aspect-ratio: 1/1;
    background-color: var(--secondary);
    padding: 1.5rem;
  }
  .reverse .mask_one {
    margin-left: -10%;
    margin-right: 0;
    background-color: var(--orange);
  }
  .reverse .mask_two {
    background-color: var(--orange-light);
    padding: 1.5rem;
  }
  .reverse .mask_tree {
    background-color: var(--orange);
  }
  .reverse .mask_four {
    background-color: var(--orange-light);
  }
  .flower {
    aspect-ratio: 1/1;
    width: 100%;
  }
  .flower img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  .info h3 {
    font-size: clamp(5rem, 10svw, 24rem);
    color: var(--white);
    font-family: sirenia;
    line-height: 1;
    width: 100%;
  }
  .info h5 {
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    color: var(--white);
    line-height: 1;
    margin: -2rem 0 1rem 0;
  }
  .info p {
    font-size: clamp(1.8rem, 2vw, 2.2rem);
    color: var(--white);
    max-width: 620px;
  }
  .info a {
    display: block;
    margin-top: 6rem;
  }
  .decorate-orange {
    position: absolute;
    top: 30%;
    left: 3vw;
    transform: translateY(-50%);
    z-index: 2;
    width: 8%;
  }
  .decorate-pink {
    position: absolute;
    top: inherit;
    right: 2rem;
    bottom: 0;
    z-index: 2;
    width: 12%;
  }
  @media (min-width: 1600px) {
    .label-back {
      gap: 20%;
    }
    .reverse > .label-back {
      gap: 20%;
    }
  }
  @media (max-width: 1366px) {
    .label-back {
      gap: 13%;
    }
    .reverse .label-back {
      gap: 15%;
    }
    .decorate-orange {
      display: none;
    }
  }
  @media (max-width: 1180px) {
    .label-back {
      padding-left: 10px;
    }
  }
  @media (max-width: 820px) {
    .mask_one,
    .mask_two,
    .mask_tree,
    .mask_four {
      padding: 1rem;
    }
  }
  @media (max-width: 767px) {
    .container {
      display: grid;
      justify-content: center;
      align-items: flex-start;
      width: 100vw;
      min-height: 200vw;
    }
    .mask_one {
      width: 95svw;
      height: 95svw;
      padding: 1rem;
      margin-right: 0;
    }
    .reverse .mask_one {
      margin-left: 0;
    }
    .label-back {
      background: transparent linear-gradient(45deg, #fb5caa 0%, #f5dfe7 100%) 0% 0% no-repeat
        padding-box;
    }
    .reverse .label-back {
      background: transparent linear-gradient(45deg, #fb5caa 0%, #fdb048 100%) 0% 0% no-repeat
        padding-box;
    }
    .label-back,
    .reverse .label-back {
      flex-direction: column-reverse;
      height: 90%;
    }
    .mask_back {
      height: 45%;
      background-color: transparent;
    }
    .reverse .mask_back {
      height: 45%;
      background-color: transparent;
    }
    .decorate-orange,
    .decorate-pink {
      display: none;
    }
    .info {
      margin-bottom: 3rem;
    }
    .info h3 {
      font-size: clamp(5rem, 20svw, 13.6rem);
      padding-bottom: 1rem;
    }
    .info a {
      margin-top: 2rem;
    }
  }
</style>
